export default "__VITE_ASSET__CuLCQh9B__"